export default {
  config: './config.ts',
};
